export function interpretApiError(error) {
  const detail = error?.response?.data?.detail;

  if (!detail) {
    return {
      type: "error",
      title: "Something went wrong",
      message:
        "We couldn't complete your request right now. Please try again.",
    };
  }

  if (typeof detail === "string") {
    return {
      type: "error",
      title: "Action unavailable",
      message: detail,
    };
  }

  const reason = detail?.reason;

  switch (reason) {
    case "saved_hook_limit_reached":
      return {
        type: "upgrade",
        modal: "creator",
        reason,
        title: "Free save limit reached",
        message:
          "You’ve reached your free saved hook limit. Upgrade to Creator to save more hooks and unlock premium tools.",
      };

    case "monthly_generation_limit_reached":
      return {
        type: "upgrade",
        modal: "creator",
        reason,
        title: "Monthly generation limit reached",
        message:
          "You’ve used all your free monthly generations. Upgrade to continue creating without interruption.",
      };

    case "creator_plan_required":
      return {
        type: "upgrade",
        modal: "creator",
        reason,
        title: "Creator feature",
        message:
          "This feature is available on the Creator plan.",
      };

    case "pro_plan_required":
      return {
        type: "upgrade",
        modal: "pro",
        reason,
        title: "Pro feature",
        message:
          "This feature is available on the Pro plan.",
      };

    case "session_expired":
      return {
        type: "auth",
        reason,
        title: "Session expired",
        message:
          "Your session expired. Please log in again.",
      };

    default:
      return {
        type: "error",
        title: "Action unavailable",
        message:
          detail?.message ||
          "We couldn't complete your request right now.",
      };
  }
}
